import { render, staticRenderFns } from "./ALFolder.vue?vue&type=template&id=13b6434b"
import script from "./ALFolder.vue?vue&type=script&lang=js"
export * from "./ALFolder.vue?vue&type=script&lang=js"
import style0 from "./ALFolder.vue?vue&type=style&index=0&id=13b6434b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports